import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { WidgetSunstudyView } from '../../../models/widget';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SunstudyService } from '../../sunstudy.service';
import { FileUploader } from 'ng2-file-upload';
import { Auth } from '../../../auth/auth.service';

@Component({
  selector: 'cw-sunstudy-view-form',
  templateUrl: './sunstudy-view-form.component.html',
  styleUrls: ['./sunstudy-view-form.component.scss']
})
export class SunstudyViewFormComponent implements OnChanges {
  @Input() view: WidgetSunstudyView;
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();

  @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  currentFrame: number = 1;
  isUploading: boolean = false;

  uploader: FileUploader = new FileUploader({});
  hasBaseDropZoneOver: boolean = false;

  constructor(private fb: FormBuilder,
              private auth: Auth,
              private sunstudyService: SunstudyService) {
    this.buildForm();

    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
      this.uploader.authToken = 'Bearer ' + this.auth.getToken();
    };

    this.uploader.onAfterAddingAll = f => {
      //this.uploader.uploadAll();
    };

    this.uploader.onCompleteItem = (item, response) => {

    };

    this.uploader.onCompleteAll = () => {
      this.saved.emit(this.form.value);
    };
  }

  ngOnChanges() {
    if (this.view) {
      this.currentFrame = this.view.startFrame;

      this.form.setValue({
        name: this.view.name,
        slug: this.view.slug,
        starthour: this.view.startHour,
        endhour: this.view.endHour,
        startframe: this.view.startFrame
      });

      this.uploader.setOptions({
        url: `${this.view.url}/upload`,
        authToken: "Bearer " + this.auth.getToken(),
      });

      this.isUploading = !this.view.images.length;
    }
  }

  startUpload() {
    this.sunstudyService.deleteViewFiles(this.view).subscribe(ok => {
      this.uploader.uploadAll();
    });
  }

  deleteView() {
    this.deleted.emit();
  }

  moveUp(item, i) {
    //this.splice(to, 0, this.splice(from, 1)[0]);
    this.uploader.queue.splice(i - 1, 0, this.uploader.queue.splice(i, 1)[0]);
  }

  moveDown(item, i) {
    this.uploader.queue.splice(i + 1, 0, this.uploader.queue.splice(i, 1)[0]);
  }

  save() {
    const value = this.form.value;
    if (this.view) {
      this.view.name = value.name;
      this.view.startHour = value.starthour;
      this.view.endHour = value.endhour;
      this.view.startFrame = value.startframe;
      this.sunstudyService.updateView(this.view).subscribe(view => {
      });
    } else {
      this.saved.emit(this.form.value);
    }
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  get uploadInProgress() {
    return this.uploader.isUploading;
  }

  private buildForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      slug: ['', Validators.required],
      starthour: ['', Validators.required],
      endhour: ['', Validators.required],
      startframe: ['', Validators.required],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/sunstudio-modal/sunstudy-view-form/sunstudy-view-form.component.ts